import React from 'react';
import PageWrapper from '../layout/PageWrapper';
import { Layers } from 'lucide-react';
import ZoneList from '../components/ZoneList';
import { MdImageSearch } from "react-icons/md";
import { PiHouseLineBold } from "react-icons/pi";

/**
 * Harmonisation zones:
 * - Header unique
 * - Largeur max identique
 * - Overflow horizontal pour tableaux
 * - H1 interne masqué si présent
 */
export default function ZonesPage() {
  return (
    <PageWrapper icon={PiHouseLineBold} title="Zones" maxWidth="max-w-full">
      <style>{`.page-content > h1:first-of-type{display:none}`}</style>
      <div className="page-content mx-auto max-w-7xl">
        <div className="overflow-x-auto">
          <ZoneList />
        </div>
      </div>
    </PageWrapper>
  );
}
